import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="ticket"
export default class extends Controller {
  static targets = ['positiveNumber']

  connect() {
    this.positiveNumberTargets.forEach((target) => {
      target.addEventListener('input', this.filterInput)
    })
  }

  filterInput(event) {
    event.target.value = event.target.value.replace(/^(0+)|[^0-9]/g, '')
  }
}
